// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Highlight from './utils/codelight'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/index.css'
import 'typeface-roboto'
import './assets/styles/highlight.css'
import './utils/Axios'
import router from './router'
Vue.config.productionTip = false

Vue.use(Highlight)
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
